var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBillNoSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.414,
    height: 36.414,
    viewBox: "0 0 36.414 36.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#bf0028;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(.707 .707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0 0l35 35",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M35 0L0 35",
    className: "cls-1",
    "data-name": "Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillNoSuccess);
export default __webpack_public_path__ + "static/media/icon-bill-no-success.8ab757f0b4b8bdb5aa0b35778b4b6240.svg";
export { ForwardRef as ReactComponent };